import { articles } from "@/data/articles";
import { keywordPages } from "@/data/keywordPages";

export const langPair = (pathname) => {
  let dePath;
  if (pathname === "/en" || pathname === "/en/") {
    dePath = "/";
  } else if (pathname.startsWith("/en/")) {
    const rest = pathname.slice(3);
    if (rest === "/moving-to-switzerland") dePath = "/umzug-in-die-schweiz";
    else if (rest === "/journal") dePath = "/ratgeber";
    else if (rest === "/imprint") dePath = "/impressum";
    else if (rest === "/privacy") dePath = "/datenschutz";
    else if (rest.startsWith("/journal/")) {
      const slug = rest.split("/")[2];
      const art = articles.find((a) => a.slugEn === slug);
      dePath = art ? `/ratgeber/${art.slugDe}` : "/ratgeber";
    } else {
      const kp = keywordPages.find((p) => p.slugEn === rest.slice(1));
      dePath = kp ? `/${kp.slugDe}` : rest;
    }
  } else {
    dePath = pathname;
  }

  let enPath;
  if (dePath === "/") enPath = "/en";
  else if (dePath === "/umzug-in-die-schweiz") enPath = "/en/moving-to-switzerland";
  else if (dePath === "/ratgeber") enPath = "/en/journal";
  else if (dePath === "/impressum") enPath = "/en/imprint";
  else if (dePath === "/datenschutz") enPath = "/en/privacy";
  else if (dePath.startsWith("/ratgeber/")) {
    const slug = dePath.split("/")[2];
    const art = articles.find((a) => a.slugDe === slug);
    enPath = art ? `/en/journal/${art.slugEn}` : "/en/journal";
  } else {
    const kp = keywordPages.find((p) => `/${p.slugDe}` === dePath);
    enPath = kp ? `/en/${kp.slugEn}` : "/en" + dePath;
  }

  return { de: dePath, en: enPath };
};

export const switchLangPath = (pathname, target) => {
  const pair = langPair(pathname);
  return target === "en" ? pair.en : pair.de;
};

export const localize = (path, lang) => (lang === "en" ? `/en${path === "/" ? "" : path}` : path);
